import React, {useMemo} from 'react'

export interface CopilotSettings {
  copilotAccessAllowed: boolean
  copilotSpacesEnabled: boolean
  modelsAccessAllowed: boolean
  modelsRepoIntegrationEnabled: boolean
}

const CopilotSettingsContext = React.createContext<CopilotSettings>({
  copilotAccessAllowed: false,
  copilotSpacesEnabled: false,
  modelsAccessAllowed: false,
  modelsRepoIntegrationEnabled: false,
})

interface CopilotSettingsProviderProps {
  copilotAccessAllowed?: boolean
  copilotSpacesEnabled?: boolean
  modelsAccessAllowed?: boolean
  modelsRepoIntegrationEnabled?: boolean
}

export function CopilotSettingsProvider({
  children,
  copilotAccessAllowed = false,
  copilotSpacesEnabled = false,
  modelsAccessAllowed = false,
  modelsRepoIntegrationEnabled = false,
}: React.PropsWithChildren<CopilotSettingsProviderProps>) {
  const value = useMemo(
    () => ({
      copilotAccessAllowed,
      copilotSpacesEnabled,
      modelsAccessAllowed,
      modelsRepoIntegrationEnabled,
    }),
    [copilotAccessAllowed, copilotSpacesEnabled, modelsAccessAllowed, modelsRepoIntegrationEnabled],
  )

  return <CopilotSettingsContext value={value}>{children}</CopilotSettingsContext>
}

export function useCopilotSettings() {
  return React.use(CopilotSettingsContext)
}
